import styled from "styled-components";
import { COLORS, DEVICE_TYPE, SIZE } from "constants/variables";

export const MissionSectionContainer = styled.div``;

export const MissionSectionTitleWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const MissionSectionTextWrapper = styled.div`
  padding: ${SIZE.max24} ${SIZE.max360};
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    padding: ${SIZE.max24} ${SIZE.max200};
  }
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    padding: ${SIZE.max24} ${SIZE.max100};
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    padding: ${SIZE.max24} ${SIZE.max60};
  }
`;

export const MissionSectionCarouselContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  gap: ${SIZE.max32};
  padding-block: ${SIZE.max100} 0;
`;

export const MissionSectionCarouselItemWrapper = styled.div`
  width: ${SIZE.max224};
  height: ${SIZE.max224};

  @media (max-width: 1750px) {
    width: ${SIZE.max280};
    height: ${SIZE.max280};
  }

  @media (max-width: 1320px) {
    width: ${SIZE.max320};
    height: ${SIZE.max320};
  }

  @media (max-width: 1050px) {
    width: ${SIZE.max330};
    height: ${SIZE.max330};
  }

  @media (max-width: 768px) {
    width: ${SIZE.max104};
  }
`;

export const MissionSectionCarouselItem = styled.div`
  background-color: ${COLORS.VividAuburn};
  border-radius: 50%;
  border: 1px solid ${COLORS.Crimson};

  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-block: ${SIZE.max55} 0;
  text-align: center;
`;

export const MissionSectionCarouselItemTitleWrapper = styled.div``;

export const MissionSectionCarouselItemTextWrapper = styled.div`
  padding-inline: ${SIZE.max18};

  @media (max-width: 768px) {
    padding-inline: ${SIZE.max32};
  }
`;

export const MissionSectionCarouselItemIconWrapper = styled.div`
  padding-block: ${SIZE.max10} 0;

  @media (max-width: 1750px) {
    padding-block: ${SIZE.max32} 0;
  }
  @media (max-width: 1320px) {
    padding-block: ${SIZE.max24} 0;
  }

  @media (max-width: 1050px) {
    padding-block: ${SIZE.max80} 0;
  }

  @media (max-width: 768px) {
    padding-block: ${SIZE.max32} 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const MissionSectionCarouselItemIcon = styled.img`
  width: ${SIZE.max80};

  @media (max-width: 1050px) {
    width: ${SIZE.max120};
  }

  @media (max-width: 768px) {
    width: ${SIZE.max120};
  }

  @media (max-width: 550px) {
    width: ${SIZE.max100};
  }
`;

export const MissionSectionCarouselContainerMobile = styled.div`
  .slick-slide {
    padding-inline: ${SIZE.max18};

    @media (max-width: 768px) {
      padding-inline: ${SIZE.max32};
      max-width: ${SIZE.max380};
    }

    @media (max-width: 400px) {
      padding-inline: ${SIZE.max18};
    }
  }
`;
